import { Button } from "@material-ui/core";
import { ChangeEvent, forwardRef, useReducer, useRef, useState } from 'react';
import { useAuth } from "../../contexts/auth";
import { useModal } from "../../contexts/modal";
import SnackBar from "../../pages/admin/layout/components/Snackback";
import axios from "../../services/api";
import InputComponent from "./Input";
import passwordReducer, { PasswordsProps } from "./reducer/password.reducer";
import { ChangePasswordButtonTypography, ChangePasswordSaveButton, ChangePasswordTitleTypography, Container, ModalBody } from "./styles";
import { ButtonContained } from "../../pages/audio/components/dialog/styles";

const initialState: PasswordsProps = {
  currentPassword: '', 
  newPassword: '', 
  confirmNewPassword: '', 
  errors: [],
  snackbar: {
    isOpen: false,
    message: '',
    type: 'info'
  }
};

const ChangePassword = forwardRef((props, ref: any) => {
  const [passwords, dispatch] = useReducer(passwordReducer, initialState);
  const [isPasswordVisible, setIsPasswordVisible] = useState({
    current: false, new: false, confirm: false
  });
  const [isDisabled, setIsDisabled] = useState(true);
  const currenPasswords = useRef({
    currentPassword: '', 
    newPassword: '', 
    confirmNewPassword: '',
  })

  const auth = useAuth();
  const modal = useModal();

  let isCurrentPasswordInvalid = passwords.errors.includes('current_password');
  let isNewPasswordInvalid = passwords.errors.includes('new_password');
  let isConfirmNewPassowrdInvalid = passwords.errors.includes('confirm_new_password');

  const handleCurrentPassword = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: 'SET_CURRENT_PASSWORD', payload: e.target.value }); 
    currenPasswords.current.currentPassword = e.target.value; 
    validateFields()
  }

  const handleNewPassword = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: 'SET_NEW_PASSWORD', payload: e.target.value }); 
    currenPasswords.current.newPassword = e.target.value;
    validateFields()
  }

  const handleConfirmNewPassword = (e: ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: 'SET_CONFIRM_NEW_PASSWORD', payload: e.target.value }); 
    currenPasswords.current.confirmNewPassword = e.target.value;
    validateFields()
  }; 

  const validateNewPassword = () => { 
    if(passwords.newPassword !== "" && 
    passwords.newPassword !== passwords.currentPassword && 
    passwords.newPassword.length >= 3 ) {
      return true;
    }

    dispatch({ type: 'SET_ERROR', payload: 'new_password' });
    dispatch({ type: 'SET_SNACKBAR', payload: { isOpen: true, message: 'A nova senha deve ser diferente da atual', type: 'error' } });
    
    return false;
  };
  const validateNewPasswordMatch = () => {
    if(passwords.newPassword.length > 0 && passwords.newPassword === passwords.confirmNewPassword) {
      return true;
    }

    dispatch({ type: 'SET_ERROR', payload: 'confirm_new_password' });
    dispatch({ type: 'SET_SNACKBAR', payload: { isOpen: true, type: 'error', message: 'As senhas devem ser compatíveis' } });
    return false;
  };

  const validateFields = () => {
    setIsDisabled(currenPasswords.current.currentPassword.length < 3 || currenPasswords.current.newPassword.length < 3 || currenPasswords.current.confirmNewPassword.length < 3);
  }

  const handleSubmit = async() => {
    let isNewPasswordValid = validateNewPassword();
    let isNewPasswordAndConfirmNewPasswordValid = validateNewPasswordMatch();
    let isAllPasswordsValid = !isCurrentPasswordInvalid && isNewPasswordValid && isNewPasswordAndConfirmNewPasswordValid;

    if(!isAllPasswordsValid) {
      return;
    }

    try {
      await axios.patch(`${process.env.REACT_APP_BASE_URL}/users-auth/${auth.sessionData?.username}/password/${passwords.currentPassword}/${passwords.newPassword}`);
      modal.openModal(false);

    }catch(err) {
      dispatch({ type: 'SET_ERROR', payload: 'current_password' });
      dispatch({ type: 'SET_SNACKBAR', payload: { isOpen: true, message: 'A senha atual está errada', type: 'error' } })
      console.log(err);
    }
  };

  const handleClickShowPassword = (fieldName: 'current' | 'new' | 'confirm') => {
    setIsPasswordVisible(prevState => ({ ...prevState, [fieldName]: !prevState[fieldName] }))
  }

  return (
    <>
      <Container ref={ref} tabIndex={-1}>
        <header>
          <ChangePasswordTitleTypography>Alterar senha</ChangePasswordTitleTypography>
        </header>
        <ModalBody>
          
            <InputComponent 
              label="Senha atual"
              value={passwords.currentPassword}
              handleChange={handleCurrentPassword}
              handleChangeVisibility={() => handleClickShowPassword('current')}
              isPasswordVisible={isPasswordVisible.current}
              error={isCurrentPasswordInvalid}
            />

            <InputComponent 
              label="Nova senha"
              value={passwords.newPassword}
              handleChange={handleNewPassword}
              handleChangeVisibility={() => handleClickShowPassword('new')}
              isPasswordVisible={isPasswordVisible.new}
              error={isNewPasswordInvalid}
            />

            <InputComponent 
              label="Confirmar nova senha"
              value={passwords.confirmNewPassword}
              handleChange={handleConfirmNewPassword}
              handleChangeVisibility={() => handleClickShowPassword('confirm')}
              isPasswordVisible={isPasswordVisible.confirm}
              error={isConfirmNewPassowrdInvalid}
              
            />
          
        </ModalBody>
        <footer>
          <ChangePasswordSaveButton disabled={isDisabled} className="save-button" onClick={handleSubmit}><ChangePasswordButtonTypography className="save-button-typography">SALVAR</ChangePasswordButtonTypography></ChangePasswordSaveButton>
        </footer>
      </Container>
      <SnackBar 
        children={<>{passwords.snackbar.message}</>}
        open={passwords.snackbar.isOpen}
        feedbackType={passwords.snackbar.type}
        setOpen={() => {}}
        dispatch={() => dispatch({ type: 'SET_SNACKBAR', payload: { isOpen: false } })}
      />
    </>
  )
});

export default ChangePassword;
